import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CurrentDataSlice {
  loggedInUserData: any;
  forgotPwdEmail: string;
  schoolOnboardingId: string | null;
}

const initialState: CurrentDataSlice = {
  loggedInUserData: null,
  forgotPwdEmail: "",
  schoolOnboardingId: null,
};

const currentDataSlice = createSlice({
  name: "currentData",
  initialState,
  reducers: {
    setLoggedInUserData(state, action: PayloadAction<any>) {
      state.loggedInUserData = action.payload;
    },
    clearLoggedInUserData(state) {
      state.loggedInUserData = null;
    },
    setForgotPwdEmail(state, action: PayloadAction<string>) {
      state.forgotPwdEmail = action.payload;
    },
    setSchoolOnboardingId(state, action: PayloadAction<string | null>) {
      state.schoolOnboardingId = action.payload;
    },
    clearSchoolOnboardingId(state) {
      state.schoolOnboardingId = null;
    },
    reset(state) {
      state.loggedInUserData = null;
      state.forgotPwdEmail = "";
      state.schoolOnboardingId = null;
    },
  },
});

export const {
  setLoggedInUserData,
  clearLoggedInUserData,
  reset,
  setForgotPwdEmail,
  setSchoolOnboardingId,
  clearSchoolOnboardingId,
} = currentDataSlice.actions;

export default currentDataSlice.reducer;
